import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Cause from "@/pages/Cause";
import EventDetails from "@/pages/EventDetails";
import Sponsor from "@/pages/Sponsor";
import Register from "@/pages/Register";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import AdminReset from "@/pages/AdminReset";
import Flyer from "@/pages/Flyer";
import ExecSummary from "@/pages/ExecSummary";
import Prospectus from "@/pages/Prospectus";
import Marketing from "@/pages/Marketing";
import SalesFlyers from "@/pages/SalesFlyers";
import SponsorKit from "@/pages/SponsorKit";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout({ children }) {
  return (
    <div className="App bg-background text-foreground min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/flyer" element={<Flyer />} />
        <Route path="/exec-summary" element={<ExecSummary />} />
        <Route path="/prospectus" element={<Prospectus />} />
        <Route path="/marketing-guide" element={<Marketing />} />
        <Route path="/sales-flyers" element={<SalesFlyers />} />
        <Route path="/sponsor-kit" element={<SponsorKit />} />
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/cause" element={<Cause />} />
                <Route path="/event" element={<EventDetails />} />
                <Route path="/sponsor" element={<Sponsor />} />
                <Route path="/register" element={<Register />} />
                <Route path="/donate" element={<Donate />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/reset" element={<AdminReset />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
